import { Link } from "react-router";

import { Badge } from "@/components/ui/badge";
import type { AreaVenueItem } from "@/types/area";

/** The venues that sit in this area; each row opens the venue. Hidden ones are marked. */
export const AreaVenuesPanel = ({
  venues,
  error,
  emptyText = "No venues in this area.",
}: {
  venues: AreaVenueItem[];
  error?: string;
  emptyText?: string;
}) => {
  if (error) {
    return (
      <p role="alert" className="text-sm text-destructive">
        Could not load the venues: {error}
      </p>
    );
  }
  if (venues.length === 0) {
    return <p className="text-sm text-muted-foreground">{emptyText}</p>;
  }
  return (
    <ul className="flex max-h-96 flex-col divide-y overflow-y-auto text-sm">
      {venues.map((v) => (
        <li
          key={v.id}
          className="flex items-center justify-between gap-2 py-1.5"
        >
          <Link
            to={`/venues/edit/${encodeURIComponent(v.id)}`}
            className="truncate hover:underline"
          >
            {v.name}
          </Link>
          {v.hide && <Badge variant="secondary">Hidden</Badge>}
        </li>
      ))}
    </ul>
  );
};
